export interface Item {
  ItemNo?: number;
  SlNo?: string;
  PrdDesc: string;
  HsnCd: string;
  Qty: number | string;
  Unit: string;
  UnitPrice: number;
  AssAmt: number;
  GstRt: number;
  IgstAmt?: number;
  CgstAmt?: number;
  SgstAmt?: number;
  TotItemVal: number;
}

export interface PartyDetails {
  Gstin?: string;
  LglNm?: string;
  TrdNm?: string;
  Addr1?: string;
  Addr2?: string | null;
  Loc?: string;
  Pin?: number | string;
  Stcd?: number | string;
  Ph?: string;
  Em?: string;
  Pos?: string;
}

export interface DispatchDetails extends PartyDetails {
  Nm?: string;
}

export interface ExtractedInvoice {
  AckNo?: number | string;
  AckDt?: string;
  Irn?: string;
  DocDtls?: {
    Typ?: string;
    No?: string;
    Dt?: string;
  };
  SellerDtls?: PartyDetails;
  BuyerDtls?: PartyDetails;
  DispDtls?: DispatchDetails;
  ShipDtls?: PartyDetails | null;
  ValDtls?: {
    AssVal?: number;
    CgstVal?: number;
    SgstVal?: number;
    IgstVal?: number;
    RndOffAmt?: number;
    TotInvVal?: number;
  };
  ItemList?: Item[];
  EwbDtls?: {
    EwbNo?: string | number;
    EwbDt?: string;
    EwbValidTill?: string;
    Distance?: number | string;
    VehNo?: string;
    TransId?: string;
    TransName?: string;
    TransDocNo?: string;
    TransDocDt?: string;
    TransMode?: "1" | "2" | "3" | "4";
    VehType?: "R" | "O";
  } | null;
}

export interface InvoiceGoodsSerialGroup {
  type: "product" | "material";
  product?: {
    _id?: string;
    productName?: string;
    name?: string;
  };
  rawMaterial?: {
    _id?: string;
    name?: string;
    productName?: string;
  };
  goodsIds: string[];
  serialNumbers: string[];
}
export type InvoiceItemType = "product" | "material";

export interface InvoiceSerialNumberGroup {
  name?: string;
  productName?: string;
  type: InvoiceItemType;
  serialNumbers: string[];
}
export interface InvoiceData {
  _id?: string;
  orderId?: string;
  status?: string;
  transportPrice?: number;
  invoiceNumber?: string;
  goods?: InvoiceGoodsSerialGroup[];
  ackNo?: string | number | null;
  ackDate?: string | Date | null;
  irn?: string;
  signedInvoice?: string;
  signedQRCode?: string;
  qrCodeImage?: string;
  ewbNo?: string | number | null;
  ewbDate?: string | Date | null;
  ewbValidTill?: string | Date | null;
  ewbDistance?: number | string | null;
  ewbVehNo?: string | null;
  ewbTransId?: string | null;
  ewbTransName?: string | null;
  ewbTransDocNo?: string | null;
  ewbTransDocDt?: string | Date | null;
  ewbTransMode?: "1" | "2" | "3" | "4" | null;
  ewbVehType?: "R" | "O" | null;
  extractedQRCode?: Record<string, unknown>;
  extractedInvoice?: ExtractedInvoice;
  netMeterPayment?: number | null;
  serialNumbers?: InvoiceSerialNumberGroup[];
  taxProResponse?: {
    AckNo?: string | number | null;
    AckDt?: string | Date | null;
    Irn?: string;
    SignedInvoice?: string;
    SignedQRCode?: string;
    Status?: string;
    ExtractedSignedInvoiceData?: ExtractedInvoice;
    EwbNo?: string | number | null;
    EwbDt?: string | Date | null;
    EwbValidTill?: string | Date | null;
    Distance?: number | string | null;
    VehNo?: string | null;
    TransId?: string | null;
    TransName?: string | null;
    TransDocNo?: string | null;
    TransDocDt?: string | Date | null;
    TransMode?: "1" | "2" | "3" | "4" | null;
    VehType?: "R" | "O" | null;
    QrCodeImage?: string;
    ExtractedSignedQrCode?: Record<string, unknown>;
    InfoDtls?: {
      InfCd?: string;
      Desc?: {
        ErrorCode?: string;
        ErrorMessage?: string;
      }[];
    }[];
  };
}

export interface EwbDtls {
  TransId?: string;
  TransName?: string;
  Distance: number;
  TransDocNo?: string;
  TransDocDt: string; // DD/MM/YYYY
  VehNo?: string;
  VehType: "R" | "O";
  TransMode: "1" | "2" | "3" | "4";
}

export const EINVOICE_STATUSES = [
  "ACTIVE",
  "PENDING",
  "CANCELLED",
  "FAILED",
  "TALLY_TRANSFFERED",
] as const;

export type EInvoiceStatus = (typeof EINVOICE_STATUSES)[number];

export interface EinvoiceListItem {
  _id: string;
  orderId: string;
  invoiceNumber: string;
  status: EInvoiceStatus;
  ackNo?: string | null;
  ackDate?: string | null;
  irn?: string | null;
  ewbNo?: string | null;
  ewbDate?: string | null;
  ewbValidTill?: string | null;
  tallyTransferred: boolean;
  tallyTransferError?: string | null;
  createdAt: string;
  updatedAt: string;
  order?: {
    orderNumber?: string;
  };
  customer?: {
    name?: string;
    mobileNumber?: string;
  };
}
